export default "__VITE_ASSET__QWq1Rsae__"